export const theme = {
  primaryDark: '#0D0C1D',
  primaryLight: '#FFF',
  primaryHover: '#343078',
  lightGrey: '#f2f2f2',
  darkGrey: '#999999',
  mobile: '576px',
}
